import React from 'react'
import { Grid } from '@softwaredev_cegeka/stix-core'
import fiveHundred from 'src/assets/images/500.svg'

export default function NotFound() {
    return (
        <Grid.Container className={'page-body error-page'}>
            <h1 className={'error-title'}>Page not found</h1>
            <h2 className={'error-status'}>404</h2>
            <div
                style={{
                    maxWidth: '50%',
                    margin: 'auto',
                }}
            >
                <img src={fiveHundred} alt={''} />
            </div>
        </Grid.Container>
    )
}
